'use strict'

import ApiClient from './ApiClient'

export default class ProfileSettingRepository {
  /**
   * プロフィール取得
   * @param params get_rels
   * @returns {*}
   */
  get (params) {
    return ApiClient().get(`/profiles`, { params })
  }

  /**
   * プロフィール更新
   * @param formData 登録データ
   * @returns {*}
   */
  put (formData) {
    formData.append('_method', 'PUT')

    return ApiClient().post(`/profiles`, formData, {
      headers: ApiClient().getFormHeaders(formData)
    })
  }
}



// WEBPACK FOOTER //
// ./src/repositories/ProfileSettingRepository.js